<template>
<div class="nettdoc-side-face">
  <div class="nettdoc-side-face__wrapper" :style="active ? 'width:80%;max-width:500px' : ''">
    <svg xmlns="http://www.w3.org/2000/svg" width="138" height="138" viewBox="0 0 138 138">
        <g fill="none" fill-rule="evenodd">
            <path fill="#FFF" d="M0 0h138v138H0z"/>
            <path fill="#43A6DD" d="M28.282 88.184A7 7 0 1 1 24.4 75.025C24.137 73.055 24 71.043 24 69c0-24.853 20.147-45 45-45s45 20.147 45 45-20.147 45-45 45c-17.991 0-33.516-10.558-40.718-25.816z"/>
            <path stroke="#3788B5" stroke-width="5" d="M71.58 79.851C72.617 80.588 73.776 81 75 81c4.418 0 8-5.373 8-12s-3.582-12-8-12c-2.728 0-5.137 2.048-6.58 5.175"/>
            <path fill="#DBE2E8" d="M31.087 44.75C39.086 32.27 53.077 24 69 24c24.853 0 45 20.147 45 45 0 12.567-5.151 23.93-13.457 32.094a47.68 47.68 0 0 1-20.97-23.486C81.07 75.428 82 72.377 82 69c0-6.627-3.582-12-8-12-2.581 0-4.877 1.834-6.34 4.68-14.134-1.436-26.866-7.62-36.573-16.93z"/>
            <path stroke="#3A424A" stroke-width="3" d="M35.804 99c5.607 0 10.92-1.265 15.667-3.524"/>
            <ellipse cx="39" cy="72" fill="#3A424A" rx="6" ry="7"/>
            <g>
              <path class="nettdoc-bodysection" @click="selectLocation('sideface_forehead')" :class="[choice && choice.includes('sideface_forehead') ? 'nettdoc-is-active': '', !active ? 'nettdoc-no-hover' : '']" d=" M 0 0 L 46 0 L 46 46 L 0 46 L 0 0 Z " fill-rule="evenodd" fill="none" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(184,226,245)" stroke-linejoin="miter" stroke-linecap="butt" stroke-miterlimit="4" />
              <path class="nettdoc-bodysection" @click="selectLocation('sideface_nose/eyes')" :class="[choice && choice.includes('sideface_nose/eyes') ? 'nettdoc-is-active': '', !active ? 'nettdoc-no-hover' : '']" d=" M 0 46 L 46 46 L 46 92 L 0 92 L 0 46 Z " fill-rule="evenodd" fill="none" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(184,226,245)" stroke-linejoin="miter" stroke-linecap="butt" stroke-miterlimit="4" />
              <path class="nettdoc-bodysection" @click="selectLocation('sideface_tophead')" :class="[choice && choice.includes('sideface_tophead') ? 'nettdoc-is-active': '', !active ? 'nettdoc-no-hover' : '']" d=" M 46 0 L 92 0 L 92 46 L 46 46 L 46 0 Z " fill-rule="evenodd" fill="none" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(184,226,245)" stroke-linejoin="miter" stroke-linecap="butt" stroke-miterlimit="4" />
              <path class="nettdoc-bodysection" @click="selectLocation('sideface_ears')" :class="[choice && choice.includes('sideface_ears') ? 'nettdoc-is-active': '', !active ? 'nettdoc-no-hover' : '']" d=" M 46 46 L 92 46 L 92 92 L 46 92 L 46 46 Z " fill-rule="evenodd" fill="none" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(184,226,245)" stroke-linejoin="miter" stroke-linecap="butt" stroke-miterlimit="4" />
              <path class="nettdoc-bodysection" @click="selectLocation('sideface_top-backhead')" :class="[choice && choice.includes('sideface_top-backhead') ? 'nettdoc-is-active': '', !active ? 'nettdoc-no-hover' : '']" d=" M 92 0 L 138 0 L 138 46 L 92 46 L 92 0 Z " fill-rule="evenodd" fill="none" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(184,226,245)" stroke-linejoin="miter" stroke-linecap="butt" stroke-miterlimit="4" />
              <path class="nettdoc-bodysection" @click="selectLocation('sideface_center-backhead/neck')" :class="[choice && choice.includes('sideface_center-backhead/neck') ? 'nettdoc-is-active': '', !active ? 'nettdoc-no-hover' : '']" d=" M 92 46 L 138 46 L 138 92 L 92 92 L 92 46 Z " fill-rule="evenodd" fill="none" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(184,226,245)" stroke-linejoin="miter" stroke-linecap="butt" stroke-miterlimit="4" />
              <path class="nettdoc-bodysection" @click="selectLocation('sideface_mouth')" :class="[choice && choice.includes('sideface_mouth') ? 'nettdoc-is-active': '', !active ? 'nettdoc-no-hover' : '']" d=" M 0 92 L 46 92 L 46 138 L 0 138 L 0 92 Z " fill-rule="evenodd" fill="none" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(184,226,245)" stroke-linejoin="miter" stroke-linecap="butt" stroke-miterlimit="4" />
              <path class="nettdoc-bodysection" @click="selectLocation('sideface_throat')" :class="[choice && choice.includes('sideface_throat') ? 'nettdoc-is-active': '', !active ? 'nettdoc-no-hover' : '']" d=" M 46 92 L 92 92 L 92 138 L 46 138 L 46 92 Z " fill-rule="evenodd" fill="none" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(184,226,245)" stroke-linejoin="miter" stroke-linecap="butt" stroke-miterlimit="4" />
              <path class="nettdoc-bodysection" @click="selectLocation('sideface_bottom-backhead/neck')" :class="[choice && choice.includes('sideface_bottom-backhead/neck') ? 'nettdoc-is-active': '', !active ? 'nettdoc-no-hover' : '']" d=" M 92 92 L 138 92 L 138 138 L 92 138 L 92 92 Z " fill-rule="evenodd" fill="none" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(184,226,245)" stroke-linejoin="miter" stroke-linecap="butt" stroke-miterlimit="4" />
            </g>
        </g>
    </svg>
  </div>
</div>
</template>

<script>
import { observer } from "mobx-vue";
export default observer({
    name: "SymptomLocationSideFace",
    props: {
        choice: [String, Array],
        active: Boolean,
        preview: Boolean
    },
    methods: {
        selectLocation: function(value) {
          if (!this.active) {
            this.$emit('show')
            return
          }
          this.$emit('action', value)
        }
    }
})
</script>

<style lang="scss" scoped>
.nettdoc-side-face {
  svg {
    width: 100%;
    height: 100%;
  }
  .nettdoc-no-hover {
    &:hover {
      fill: unset;
      cursor: pointer;
    }
  }
  .nettdoc-is-active {
      fill: rgba(232, 108, 96, 0.6) !important;
  }
  &__wrapper {
      width: fit-content;
      margin: auto;
      position: relative;
      display: flex;
  }
}
.nettdoc-bodysection {
  fill: rgba(184, 226, 245, 0.01);
  cursor: pointer;
}
.nettdoc-bodysection:hover {
  fill: rgba(184, 226, 245, 0.6);
}
.nettdoc-preview * {
  cursor: initial !important;
}
</style>